import {PlanElement, ProcessedStatusesMeetingRoom, Workspace} from '@innowise-group/core';
import {Elements} from 'react-flow-renderer';

import {PlanElementData} from '../components/plan-element-view';
import {WorkspaceElementData} from '../components/workspace-view';
import {TypeRoomEnum} from '@shared/utilities/determine-room-meeting-id.utility';

const checkMeetingRoomStatus = (roomData: Partial<PlanElement>, statuses: ProcessedStatusesMeetingRoom) => {
  return roomData?.roomType === TypeRoomEnum.Meeting &&
    roomData?.meetingRoomId &&
    Object.hasOwn(statuses, roomData?.meetingRoomId)
    ? statuses[roomData?.meetingRoomId]
    : null;
};

export const mapRoomsToElements = (
  data: PlanElement[],
  isViewMode: boolean,
  _selectable: boolean,
  meetingRoomStatuses: ProcessedStatusesMeetingRoom,
): Elements<PlanElementData> =>
  data &&
  data.map(({id, coordinates, type, ...rest}) => {
    const baseData = {
      id: `${type}-${id}`,
      type,
      data: {
        id,
        coordinates,
        isViewMode,
        type,
        ...rest,
      },
      draggable: false,
      // RF AABB must not select rooms; polygon hit-test handles selection.
      selectable: false,
      position: {
        x: coordinates[0][0],
        y: coordinates[0][1],
      },
    };

    const meetingRoomData = checkMeetingRoomStatus(rest, meetingRoomStatuses);

    if (meetingRoomData) {
      const {capacity, ...leftData} = meetingRoomData;

      return {
        ...baseData,
        data: {
          ...baseData.data,
          capacity,
          meetingRoomStatus: leftData,
        },
      };
    }
    return baseData;
  });

export const mapViewToElements = (
  data: PlanElement[],
  options?: {selectable?: boolean; isViewMode?: boolean},
): Elements<PlanElementData> =>
  data &&
  data.map(({id, type, coordinates, ...rest}) => {
    return {
      id: `${type}-${id}`,
      type,
      data: {
        type,
        coordinates,
        id,
        isViewMode: options?.isViewMode,
        ...rest,
      },
      draggable: false,
      selectable: options?.selectable ?? false,
      position: {
        x: coordinates[0][0],
        y: coordinates[0][1],
      },
    };
  });

export const mapWorkspaceToElements = (data: Workspace[], isViewMode: boolean): Elements<WorkspaceElementData> =>
  data &&
  data.map(({id, type, coordinates, ...rest}) => {
    return {
      id: `${type}-${id}`,
      type,
      dragHandle: `.${type}`,
      data: {
        id,
        type,
        isViewMode,
        coordinates,
        ...rest,
      },
      selectable: true,
      draggable: !isViewMode,
      position: {
        x: coordinates[0][0] - 50,
        y: coordinates[0][1] - 25,
      },
    };
  });
